/**
 * Next Level Theme JavaScript
 */

// Front-end behavior for custom blocks
// import '../../blocks/accordion/accordion.js';

// Generic scroll-parallax - opt in per block via a ".has-parallax" marker
// class (hero-content heading, text-image photo). No-op if neither exists on
// the page, and skipped entirely under prefers-reduced-motion.
function initParallax() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    var targets = [];

    document.querySelectorAll(".hero-content.has-parallax").forEach(function(container) {
        var heading = container.querySelector("h1, h2, h3, h4, h5, h6");
        if (heading) targets.push({ el: heading, container: container, speed: 0.15, scale: null });
    });

    // Scoped to the advanced-image block's own wrapper (its WP-generated
    // default classname), not just "any img in the block" - the text column
    // can contain its own inline images (e.g. a logo) that must stay put.
    // Translates the whole photo (box + image together, no scale) so it
    // drifts as one intact unit rather than sliding/zooming inside its frame.
    document.querySelectorAll(".sample-text-image.has-parallax .wp-block-next-level-core-advanced-image").forEach(function(photo) {
        var container = photo.closest(".sample-text-image");
        if (container) targets.push({ el: photo, container: container, speed: 0.06, scale: null });
    });

    if (!targets.length) return;

    var active = new Set();
    var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            var target = targets.find(function(t) { return t.container === entry.target; });
            if (!target) return;
            if (entry.isIntersecting) active.add(target); else active.delete(target);
        });
    }, { rootMargin: "20% 0px" });
    targets.forEach(function(t) { observer.observe(t.container); });

    var ticking = false;
    function update() {
        active.forEach(function(t) {
            var rect = t.container.getBoundingClientRect();
            var offset = ((rect.top + rect.height / 2) - window.innerHeight / 2) * -t.speed;
            t.el.style.transform = t.scale
                ? "scale(" + t.scale + ") translate3d(0," + offset + "px,0)"
                : "translate3d(0," + offset + "px,0)";
        });
        ticking = false;
    }
    window.addEventListener("scroll", function() {
        if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
}

jQuery(document).ready(function($) {

    initParallax();


    // Side panel open/close
    $("#menu-toggle").click(function() {
        $("#side-panel").toggleClass("is-open");
        $("#side-panel-overlay").toggleClass("is-visible");
        $(this).toggleClass("is-active");
        $("body").toggleClass("menu-open");
        var isOpen = $("#side-panel").hasClass("is-open");
        $("#side-panel").attr("aria-hidden", String(!isOpen));
    });

    $("#side-panel-close, #side-panel-overlay").click(function() {
        $("#side-panel").removeClass("is-open");
        $("#side-panel-overlay").removeClass("is-visible");
        $("#menu-toggle").removeClass("is-active");
        $("body").removeClass("menu-open");
        $("#side-panel").attr("aria-hidden", "true");
    });

    $(document).on("keydown", function(e) {
        if (e.key === "Escape") $("#side-panel-close").click();
    });

    // Nav links are same-page anchors now, not full page loads - close the
    // panel explicitly so it doesn't stay open over the scrolled-to section
    $(document).on("click", ".side-panel-menu-item a", function() {
        $("#side-panel-close").click();
    });

    // Desktop search toggle
    $("#desktop-search-toggle").on("click", function() {
        $("#desktop-search-wrapper").toggleClass("is-open");
        var isOpen = $("#desktop-search-wrapper").hasClass("is-open");
        $(this).attr("aria-expanded", String(isOpen));
        if (isOpen) {
            $(".desktop-nav").addClass("is-hidden");
            setTimeout(function() {
                $("#desktop-search-input").focus();
            }, 50);
        } else {
            setTimeout(function() {
                $(".desktop-nav").removeClass("is-hidden");
            }, 300);
        }
    });

    // Close desktop search on click outside
    $(document).on("click", function(e) {
        if (!$(e.target).closest("#desktop-search-toggle, #desktop-search-wrapper").length) {
            $("#desktop-search-wrapper").removeClass("is-open");
            $("#desktop-search-toggle").attr("aria-expanded", "false");
            setTimeout(function() {
                $(".desktop-nav").removeClass("is-hidden");
            }, 300);
        }
    });

});